module.exports = __webpack_public_path__ + "img/icon-route-label-up.d95d85da.svg";